import { useState } from 'react'
import { XCircle } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'

interface DeclineRecordDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: (comment: string) => Promise<void>
  isLoading: boolean
}

export function DeclineRecordDialog({ open, onClose, onConfirm, isLoading }: DeclineRecordDialogProps) {
  const [comment, setComment] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleConfirm = async () => {
    setError(null)
    try {
      await onConfirm(comment.trim())
      setComment('')
    } catch (e) {
      setError((e as Error).message ?? 'خطا در رد کردن سابقه')
    }
  }

  const handleClose = () => {
    setComment('')
    setError(null)
    onClose()
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <XCircle className="w-5 h-5 text-red-400" />
            رد کردن سابقه؟
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          با رد کردن این سابقه، وضعیت آن به «نیاز به اصلاح» تغییر می‌یابد و دلیل رد به ثبت‌کننده نمایش داده می‌شود.
        </p>

        <div className="space-y-2">
          <Label className="text-sm">دلیل رد <span className="text-destructive">*</span></Label>
          <Textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="توضیح دهید چه چیزی نیاز به اصلاح دارد..."
            rows={4}
            dir="rtl"
          />
        </div>

        {error && (
          <p className="text-sm text-destructive">{error}</p>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>انصراف</Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading || comment.trim().length === 0}
            variant="destructive"
          >
            {isLoading ? 'در حال رد...' : 'رد کردن سابقه'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
